import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { screens } from '../data/screens';
const steps = [{
  title: 'See who needs to pay whom',
  body: 'Pair by pair, no group maths.'
}, {
  title: 'Send a nudge',
  body: 'KittyPot does the asking for you.'
}, {
  title: 'Share bank details, if you want to',
  body: 'Optional, and only when you choose to send them.'
}, {
  title: 'Mark it as paid',
  body: 'Once the money has actually moved.'
}, {
  title: 'They confirm it landed',
  body: 'Both sides agree, and it’s closed.'
}];
export function SettleUp() {
  return <section className="bg-white py-20 lg:py-28" data-id="element-284" data-mp="3tjm06cz6meo">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-285" data-mp="3v15vifmdlj3g">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="mb-14 max-w-2xl" data-id="element-286" data-mp="3v2h2eob4b6ys">
          <h2 className="mb-5 text-3xl font-black leading-[1.05] tracking-tight text-kitty-dark md:text-4xl lg:text-5xl" data-id="element-287" data-mp="26lo7ezu6lx0p">
            Settle up without the awkward chase.
          </h2>
          <p className="text-lg leading-relaxed text-gray-600 lg:text-xl" data-id="element-288" data-mp="2aot76umvnkln">
            KittyPot works out who needs to pay whom, sends the ask, and keeps
            the record once it's done.
          </p>
        </motion.div>

        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-289" data-mp="2pksfa59zlkqs">
          {/* The five steps */}
          <motion.ol initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.06
            }
          }
        }} className="lg:col-span-7" data-id="element-290" data-mp="2tlc8wyvcq686">
            {steps.map((step, index) => <motion.li key={step.title} variants={{
            hidden: {
              opacity: 0,
              y: 12
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.35,
                ease: [0.22, 1, 0.36, 1]
              }
            }
          }} className="flex gap-5 border-b border-gray-100 py-5 last:border-0" data-id="element-291" data-mp="388xcetw527gm" data-mpi={index}>
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-kitty-yellow text-base font-black text-kitty-dark" data-id="element-292" data-mp="2skis60adxa3z">
                  {index + 1}
                </span>
                <div data-id="element-293" data-mp="31c2m8942uvsm">
                  <h3 className="text-lg font-extrabold text-kitty-dark" data-id="element-294" data-mp="31ckobmdf848g">
                    {step.title}
                  </h3>
                  <p className="text-base text-gray-600" data-id="element-295" data-mp="3g80p0a8iaydt">{step.body}</p>
                </div>
              </motion.li>)}
          </motion.ol>

          {/* What the other person actually receives */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-5" data-id="element-296" data-mp="1gxirw2c1mgmx">
            <p className="mb-4 text-sm font-black uppercase tracking-widest text-kitty-yellow-700" data-id="element-297" data-mp="1di52no0dx8f">
              What they get
            </p>
            <div className="overflow-hidden rounded-3xl border border-gray-100 shadow-card" data-id="element-298" data-mp="3ntmba27wyh92">
              <img src={screens.paymentRequest.src} alt={screens.paymentRequest.alt} className="block w-full" data-id="element-299" data-mp="39ucylcix259u" />
            </div>
          </motion.div>
        </div>

        {/* Trust statement */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.45
      }} className="mt-14 flex flex-col gap-4 rounded-3xl bg-gray-950 p-8 text-white sm:flex-row sm:items-center sm:gap-6 lg:p-10" data-id="element-300" data-mp="2zxrssoz2oq4y">
          <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-kitty-yellow" data-id="element-301" data-mp="2z6jpa1k6qlfb">
            <ShieldCheckIcon className="h-6 w-6 text-kitty-dark" aria-hidden="true" data-id="element-302" data-mp="2u7gst5i9tniy" />
          </span>
          <p className="text-lg font-bold leading-relaxed sm:text-xl" data-id="element-303" data-mp="2q4af5cstwu2g">
            KittyPot doesn't hold or move your money. Payments happen directly
            between you and your friends.
          </p>
        </motion.div>
      </div>
    </section>;
}